/**
 * Client-side admin check.
 *
 * This is COSMETIC ONLY — it decides whether admin affordances are rendered.
 * It is not a security boundary: anything that actually mutates shared data is
 * re-checked server-side against PAPRIKA_ADMIN_EMAILS (see api/_lib/adminAuth.ts),
 * because a client check can always be bypassed.
 */

const ADMIN_EMAILS = ['youbbi@gmail.com'];

export function isAdminUser(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
}
